import PremiumListingGallery from './PremiumListingGallery.component';

export default PremiumListingGallery;
